import Repository from './Repository'

const resource = 'exports'

export default {
  getRawExecutions (tanantId, params) {
    return Repository.get(`${resource}/tenants/${tanantId}/raw-executions`, { params: params })
  },
  getRawExecutionsDetails (tanantId, params) {
    return Repository.get(`${resource}/tenants/${tanantId}/raw-executions-details`, { params: params })
  }
}
